import { render } from "./Cards.vue?vue&type=template&id=5589b7d5&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=5589b7d5&scoped=true&lang=scss"
import "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=5589b7d5&scoped=true&lang=css&external"
import "./Cards.vue?vue&type=style&index=2&id=5589b7d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5589b7d5"]])

export default __exports__